import { ADD_SELECTION } from '../constants';

export default function (selection) {
  return {
    type: ADD_SELECTION,
    selection,
  };
}
